<template>
  <v-container text-xs-center>
    <div id="app">
      <BaseTable :tableHeaders="headers" :tableItems="categoryItems" :tableSearch="search" :tableLoading="loading">
        <template v-slot:table-top>
          <BaseToolbar toolbarTitle="Sport Artifacts">
            <template v-slot:toolbarSearch>
              <v-text-field v-model="search" append-icon="search" label="Search Artifact" single-line
                hide-details></v-text-field>
            </template>
            <template v-slot:toolbarBtn>
              <v-dialog v-model="dialog" :retain-focus="false" max-width="700px" persistent>
                <template v-slot:activator="{ on }">
                  <v-btn color="primary" :disabled="!(user && user.role == 'Administrator')" v-on="on">{{ formTitle
                  }}</v-btn>
                </template>
              </v-dialog>
              <v-divider vertical class="mx-1" inset></v-divider>
              <v-dialog v-model="newCategoryDialog" :retain-focus="false" max-width="700px" persistent>
                <template v-slot:activator="{ on }">
                  <v-btn color="primary" :disabled="!(user && user.role == 'Administrator')" v-on="on">New
                    category</v-btn>
                </template>
              </v-dialog>
            </template>
          </BaseToolbar>
          <v-tabs style="border-top: 1px solid white;" v-model="tab" dark background-color="light-blue darken-4"
            color="white" show-arrows>
            <v-tabs-slider color="white"></v-tabs-slider>
            <v-tab v-for="item in tabItems" :key="item.node.catId" :href="'#' + `${item.node.catName}`"
              @click="updateRouter(item.node.catName)">
              <div class="tab_content">
                <span>{{ item.node.catName }}</span>
                <v-icon v-if="user && user.role === 'Administrator'" small @click="deleteTabItem">fa-times</v-icon>
              </div>
            </v-tab>
            <v-tabs-items v-model="tab">
              <v-tab-item v-for="subitem in tabItems" :key="subitem.node.catId" :value="subitem.node.catName">
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </template>
        <template v-slot:table-actions="{ actionItem }">
          <v-icon :disabled="!user || user.role != 'Administrator'" small class="mr-2"
            @click="editItem(actionItem.node)">
            edit
          </v-icon>
          <v-icon :disabled="!user || user.role != 'Administrator'" small @click="deleteItem(actionItem.node.valId)">
            delete
          </v-icon>
        </template>
      </BaseTable>
      <NewCategoryValueForm :dialog="dialog" :editData="dataToEdit" :index="editedIndex" :formTitle="formTitle"
        :active-tab-name="tab" @close-form="close" @set-loading="loading = $event" @set-dialog-to="dialog = $event">
      </NewCategoryValueForm>
      <NewCategoryForm :dialog="newCategoryDialog" :index="newCategoryEditedIndex"
        :category-types="availableCategoryTypes" @close-form="closeNewCategoryDialog" @set-loading="loading = $event">
      </NewCategoryForm>
      <v-dialog v-model="questionnaire" persistent max-width="600">
        <v-card>
          <v-card-title class="text-h5">
            <p>
              Do you confirm the deletion of the category {{ currentTabName }}
            </p>
          </v-card-title>
          <v-card-text>
            By deleting a category, you delete all its data, which may lead to
            some problems</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="closeDeleteCategoryDialog">
              Disagree
            </v-btn>
            <v-btn color="green darken-1" text @click="deleteCurrentCategory">
              Agree
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
/* eslint-disable prettier/prettier */
import { mapGetters } from "vuex";
import BaseTable from "../base/BaseTable.vue";
import BaseToolbar from "../base/BaseToolbar.vue";
import NewCategoryForm from "../forms/newCategoryForm.vue";
import NewCategoryValueForm from "../forms/newCategoryValueForm.vue";

export default {
  components: { BaseToolbar, BaseTable, NewCategoryValueForm, NewCategoryForm },
  data() {
    return {
      newCategoryDialog: false,
      newCategoryEditedIndex: -1,
      currentTabName: null,
      questionnaire: false,
      status: "active",
      search: "",
      loading: true,
      dataToEdit: false,
      on: "",
      tab: "STROKE",
      "editedItem.obsolete": "N",

      currentDate: new Date().toISOString().substr(0, 10),
      dialog: false,
      menu: false,
      name: "Default",
      nameRules: [
        v => !!v || "Name is required",
        v => (v && v.length <= 50) || "Name must be less than 10 characters"
      ],
      requiredRule: [v => !!v || "Value is required"],
      //TODO Take out this logic
      headers: [
        {
          text: "Value Name",
          align: "left",
          sortable: true,
          value: "node.valName"
        },
        { text: "Value Desc", value: "node.valDesc" },
        //{ text: "Value Name Rus", value: "node.valNameRus" },
        // { text: "Value Rus Desc", value: "node.valDescRus" },
        { text: "Obsolete", value: "node.obsolete", sort: true },
        { text: "Actions", value: "action", sortable: false }
      ],
      editedIndex: -1,
    };
  },
  created() {
    Promise.all([
      this.$store.dispatch("allCategory"),
      this.$store.dispatch("allCategoryValue")
    ]).then(() => {
      this.loading = false;
      // Set initial tab from URL if available
      if (this.$route.query.tab) {
        const tabFromUrl = this.$route.query.tab.toUpperCase();
        const exists = this.tabItems.some(item =>
          item.node.catName.toUpperCase() === tabFromUrl
        );
        if (exists) {
          this.tab = this.tabItems.find(item =>
            item.node.catName.toUpperCase() === tabFromUrl
          ).node.catName;
        }
      }
    }).catch(error => {
      console.error(error);
      this.loading = false;
    });
  },
  computed: {
    ...mapGetters(["categoryValue", "categoryList", "user"]),
    availableCategoryTypes() {
      // Extract unique category types from your category list
      if (!this.categoryList.edges) return [];
      const types = new Set();
      this.categoryList.edges.forEach(item => {
        if (item.node.catType) {
          types.add(item.node.catType);
        }
      });
      return Array.from(types);
    },
    formTitle() {
      return this.editedIndex === -1 ? "New Artifact" : "Edit Artifact";
    },
    categoryItems() {
      if (this.categoryValue.edges && this.categoryList.edges) {
        return this.categoryValue.edges.filter(
          item => item.node.category.catName === this.tab
        );
      } else {
        return [];
      }
    },
    tabItems() {
      if (this.categoryList.edges) {
        return this.categoryList.edges.filter(
          item => item.node.catType != 'ADMIN' ||
            (this.user && this.user.role == 'Administrator')
        );
      } else {
        return [];
      }
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  methods: {
    closeDeleteCategoryDialog() {
      this.questionnaire = false;
      this.currentTabName = null;
    },
    deleteCurrentCategory() {
      this.loading = true;
      if (this.currentTabName !== null && typeof this.currentTabName === "string") {
        // ? Get category id from tab name
        const categoryId = this.categoryList.edges.filter(
          el => JSON.stringify(this.currentTabName.toUpperCase()).includes(el.node.catName.toUpperCase())
        )[0].node.catId || null;
        // ? Get all category values from this category
        const categories = this.categoryValue.edges.filter(
          el => JSON.stringify(this.currentTabName.toUpperCase()).includes(el.node.category.catName.toUpperCase())
        )
        if (categoryId && categories) {
          // ? Then if all OK. Delete all cateogy values from this category
          Promise.all([categories.map(el => {
            this.$store.dispatch("categoryValueDelete", {
              valId: parseInt(el.node.valId, 10)
            })
          })])
            // ? Promise all waiting for deleing all category values.
            .then(() => {
              // ? If all OK. Delete main category
              this.$store.dispatch("categoryDelete", { catId: parseInt(categoryId, 10) })
                .then(() => {
                  this.$toast.error(`Category ${this.currentTabName} has been deleted`);
                })
                .catch(error => {
                  console.error(error);
                })
                .finally(() => {
                  this.loading = false;
                  this.closeDeleteCategoryDialog();
                })
            })
            .catch(error => {
              // ? If not. Throw error in console.
              console.error(error);
              this.loading = false;
            })
        } else {
          this.$toast.error("Sorry but tab with current id is not exist");
        }
      } else {
        this.$toast.error("Sorry but tab with this current name is not exist");
      }
    },
    updateRouter(val) {
      this.$router.replace({ query: { tab: val } });
    },
    closeNewCategoryDialog() {
      this.newCategoryDialog = false;
      this.newCategoryEditedIndex = -1;
    },
    deleteTabItem(e) {
      this.currentTabName = e.target.offsetParent.innerText
      this.questionnaire = true;
    },
    editItem(item) {
      this.dialog = true;
      this.editedIndex = 1;
      this.dataToEdit = {
        ...item,
        catId: item.category.catId // Make sure we're using the correct category ID from the item
      }
      // this.editedIndex = this.handleGetAthleteList.toString().indexOf(item);
      // this.editedIndex = this.categoryValue.edges.findIndex(
      //   x => x.node === item
      // );
      // this.editedItem = Object.assign({}, item);
      // this.dialog = true;
    },

    deleteItem(id) {
      this.loading = true;
      this.$store.dispatch("categoryValueDelete", {
        valId: parseInt(id, 10)
      })
        .then(() => {
          this.loading = false;
          this.$toast.error("Category value has been deleted")
        })
        .catch(error => {
          console.error(error);
          this.loading = false;
        });
    },

    close() {
      this.dialog = false;
      // Here we clear editedData, because we don't want to see
      // it in add new category value dialog
      this.dataToEdit = false;
      this.editedIndex = -1;
    },
  },
};
</script>
<style lang="scss">
.tab_content {
  display: flex;
  justify-content: space-around;
  align-items: center;

  span {
    margin-right: 6px;
  }
}
</style>
